module.exports = __webpack_public_path__ + "img/login-left.f5aadca4.png";